var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.computedTag,
    {
      tag: "component",
      staticClass: "button-fill",
      class:
        ((_obj = {
          active: _vm.active
        }),
        (_obj[_vm.color] = _vm.color),
        (_obj.disabled = _vm.isDisabled),
        (_obj[_vm.size] = _vm.size),
        (_obj.uppercase = _vm.uppercase),
        _obj),
      attrs: {
        "aria-disabled": _vm.isDisabled,
        disabled: _vm.isDisabled,
        href: _vm.href,
        to: _vm.to,
        title: _vm.disabledLabelText
      },
      on: { click: _vm.onClick }
    },
    [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-739f8d2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-739f8d2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/button-fill.vue
// module id = 1253
// module chunks = 0